let audio,
    gameFrame,
    isFullscreen = false,
    memoryTimer = null,
    selectedColors = [],
    correctColors = [],
    difficulty = 4,
    memoryTime = 10;

class ColorGame {
    constructor() {
        this.memoryPhase = document.querySelector('[data-phase="memory"]');
        this.selectionPhase = document.querySelector('[data-phase="selection"]');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerElement = document.querySelector('[data-timer]');
        this.colorGrid = document.querySelector('.game__color-grid');
        this.submitButton = document.querySelector('[data-submit-colors]');
        this.selectedCountElement = document.querySelector('[data-selected-count]');

        // Pobierz dane z window
        if (window.colorGameData) {
            difficulty = window.colorGameData.difficulty;
            memoryTime = window.colorGameData.memoryTime;
            correctColors = window.colorGameData.correctColors;
        }

        this.init();
    }

    init() {
        // Rozpocznij timer zapamiętywania
        this.startMemoryPhase();

        // Dodaj event listeners dla kolorów
        if (this.colorGrid) {
            const colorButtons = this.colorGrid.querySelectorAll('.game__color-option');
            colorButtons.forEach(button => {
                button.addEventListener('click', () => this.selectColor(button));
            });
        }

        // Event listener dla przycisku sprawdzenia
        if (this.submitButton) {
            this.submitButton.addEventListener('click', () => this.checkAnswers());
        }
    }

    startMemoryPhase() {
        let timeLeft = memoryTime;

        // Odtwórz dźwięk startu
        if (audio && audio.start) {
            try {
                audio.start.play().catch(e => console.log('Audio play failed:', e));
                stopAudioAfterDelay(audio.start, 2000);
            } catch(e) {
                console.log('Audio error:', e);
            }
        }

        memoryTimer = setInterval(() => {
            timeLeft--;

            if (this.timerElement) {
                this.timerElement.textContent = timeLeft;

                // Animacja ostatnich 3 sekund
                if (timeLeft <= 3) {
                    this.timerElement.classList.add('timer-warning');
                    if (audio && audio.drag) {
                        try {
                            audio.drag.play().catch(e => console.log('Audio play failed:', e));
                        } catch(e) {
                            console.log('Audio error:', e);
                        }
                    }
                }
            }

            if (timeLeft <= 0) {
                clearInterval(memoryTimer);
                this.switchToSelectionPhase();
            }
        }, 1000);
    }

    switchToSelectionPhase() {
        // Ukryj fazę zapamiętywania
        if (this.memoryPhase) {
            this.memoryPhase.classList.add('hidden');
        }

        // Pokaż fazę wyboru
        if (this.selectionPhase) {
            this.selectionPhase.classList.remove('hidden');
        }

        // Dźwięk przejścia
        if (audio && audio.drag) {
            try {
                audio.drag.play().catch(e => console.log('Audio play failed:', e));
                stopAudioAfterDelay(audio.drag, 2000);
            } catch(e) {
                console.log('Audio error:', e);
            }
        }
    }

    selectColor(button) {
        const colorName = button.dataset.colorName;
        const isSelected = button.classList.contains('selected');

        if (isSelected) {
            button.classList.remove('selected');
            selectedColors = selectedColors.filter(c => c !== colorName);

            if (audio && audio.drag) {
                try {
                    audio.drag.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.drag, 500);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }
        } else {
            // Sprawdź czy nie przekroczono limitu
            if (selectedColors.length >= difficulty) {
                // Można zaznaczyć tylko określoną ilość kolorów
                gameFrame.style.borderColor = 'red';
                setTimeout(() => {
                    gameFrame.style.borderColor = 'black';
                }, 500);

                if (audio && audio.wrong) {
                    try {
                        audio.wrong.play().catch(e => console.log('Audio play failed:', e));
                        stopAudioAfterDelay(audio.wrong, 1000);
                    } catch(e) {
                        console.log('Audio error:', e);
                    }
                }
                return;
            }

            // Zaznacz kolor
            button.classList.add('selected');
            selectedColors.push(colorName);

            if (audio && audio.valid) {
                try {
                    audio.valid.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.valid, 500);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }

            gameFrame.style.borderColor = 'yellow';
            setTimeout(() => {
                gameFrame.style.borderColor = 'black';
            }, 300);
        }

        // Aktualizuj licznik
        if (this.selectedCountElement) {
            this.selectedCountElement.textContent = selectedColors.length;
        }

        // Aktywuj/dezaktywuj przycisk sprawdzenia
        if (this.submitButton) {
            this.submitButton.disabled = selectedColors.length !== difficulty;
        }
    }

    checkAnswers() {
        // Sprawdź ile kolorów jest poprawnych
        let correctCount = 0;
        const results = [];

        selectedColors.forEach(color => {
            const isCorrect = correctColors.includes(color);
            if (isCorrect) correctCount++;

            results.push({
                name: color,
                correct: isCorrect
            });
        });

        // Przejdź do fazy wyniku
        this.showResult(correctCount, results);
    }

    showResult(correctCount, results) {
        // Ukryj fazę wyboru
        if (this.selectionPhase) {
            this.selectionPhase.classList.add('hidden');
        }

        // Pokaż fazę wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        const resultIcon = document.querySelector('[data-result-icon]');
        const resultTitle = document.querySelector('[data-result-title]');
        const resultMessage = document.querySelector('[data-result-message]');
        const correctCountElement = document.querySelector('[data-correct-count]');
        const resultList = document.querySelector('[data-result-list]');

        // Ustaw liczbę poprawnych odpowiedzi
        if (correctCountElement) {
            correctCountElement.textContent = correctCount;
        }

        // Określ wynik
        const percentage = (correctCount / difficulty) * 100;

        if (percentage === 100) {
            if (resultIcon) resultIcon.innerHTML = '<i class="fa fa-trophy result-icon--gold"></i>';
            if (resultTitle) resultTitle.textContent = 'Doskonale!';
            if (resultMessage) resultMessage.textContent = 'Zapamiętałeś wszystkie kolory! Świetna robota!';
            gameFrame.style.borderColor = 'green';

            if (audio && audio.completed) {
                try {
                    audio.completed.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.completed, 3000);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }
        } else if (percentage >= 75) {
            if (resultIcon) resultIcon.innerHTML = '<i class="fa fa-star result-icon--silver"></i>';
            if (resultTitle) resultTitle.textContent = 'Bardzo dobrze!';
            if (resultMessage) resultMessage.textContent = 'Większość kolorów została zapamiętana poprawnie!';
            gameFrame.style.borderColor = 'green';

            if (audio && audio.valid) {
                try {
                    audio.valid.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.valid, 2000);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }
        } else if (percentage >= 50) {
            if (resultIcon) resultIcon.innerHTML = '<i class="fa fa-smile-o result-icon--bronze"></i>';
            if (resultTitle) resultTitle.textContent = 'Nieźle!';
            if (resultMessage) resultMessage.textContent = 'Udało Ci się zapamiętać kilka kolorów. Spróbuj jeszcze raz!';
            gameFrame.style.borderColor = 'orange';

            if (audio && audio.drag) {
                try {
                    audio.drag.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.drag, 2000);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }
        } else {
            if (resultIcon) resultIcon.innerHTML = '<i class="fa fa-frown-o result-icon--fail"></i>';
            if (resultTitle) resultTitle.textContent = 'Spróbuj ponownie!';
            if (resultMessage) resultMessage.textContent = 'Nie udało się zapamiętać wystarczającej liczby kolorów. Spróbuj jeszcze raz!';
            gameFrame.style.borderColor = 'red';

            if (audio && audio.wrong) {
                try {
                    audio.wrong.play().catch(e => console.log('Audio play failed:', e));
                    stopAudioAfterDelay(audio.wrong, 2000);
                } catch(e) {
                    console.log('Audio error:', e);
                }
            }
        }

        // Wyświetl listę wybranych kolorów
        if (resultList) {
            resultList.innerHTML = '';
            results.forEach(result => {
                const colorItem = document.createElement('div');
                colorItem.className = `result-color-item ${result.correct ? 'correct' : 'incorrect'}`;
                colorItem.innerHTML = `
                    <span class="color-name">${result.name}</span>
                    <span class="color-status">
                        <i class="fa fa-${result.correct ? 'check' : 'times'}"></i>
                    </span>
                `;
                resultList.appendChild(colorItem);
            });
        }
    }

    reset() {
        // Wyczyść timer jeśli działa
        if (memoryTimer) {
            clearInterval(memoryTimer);
        }

        // Zresetuj wybrane kolory
        selectedColors = [];

        // Przeładuj stronę
        window.location.reload();
    }
}

function initGame() {
    gameFrame = document.querySelector('.game__frame--color-game');

    if (gameFrame) {
        loadUI();
        new ColorGame();
    }
}

function loadUI() {
    document.body.style.overflow = 'hidden';

    audio = {
        completed: new Audio('/wp-content/themes/neve/dist/audio/completed.mp3'),
        wrong: new Audio('/wp-content/themes/neve/dist/audio/wrong.mp3'),
        drag: new Audio('/wp-content/themes/neve/dist/audio/connect.wav'),
        valid: new Audio('/wp-content/themes/neve/dist/audio/ping.mp3'),
        start: new Audio('/wp-content/themes/neve/dist/audio/start.mp3')
    };

    let buttonFullscreen = gameFrame.querySelector('[data-toggle-fullscreen]'),
        buttonRestart = gameFrame.querySelectorAll('[data-game-restart]'),
        buttonBack = gameFrame.querySelector('[data-backward]');

    if (buttonFullscreen) {
        buttonFullscreen.addEventListener('click', () => {
            if (isFullscreen) {
                document.exitFullscreen();
                isFullscreen = false;
            } else {
                gameFrame.requestFullscreen();
                isFullscreen = true;
            }
            buttonFullscreen.querySelector('i').classList.toggle('fa-close');
            buttonFullscreen.querySelector('i').classList.toggle('fa-expand');
        });
    }

    if (buttonRestart.length) {
        buttonRestart.forEach(button => {
            button.addEventListener('click', () => window.location.reload());
        });
    }

    if (buttonBack) {
        buttonBack.addEventListener('click', () => history.back());
    }
}

function stopAudioAfterDelay(audioElement, delay = 2000) {
    if (!audioElement) return;

    const timeoutId = setTimeout(() => {
        try {
            if (audioElement && !audioElement.paused) {
                audioElement.pause();
                audioElement.currentTime = 0;
            }
        } catch (error) {
            console.warn('Błąd podczas zatrzymywania audio:', error);
        }
    }, delay);

    audioElement.stopTimeoutId = timeoutId;

    return timeoutId;
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-color.js